














































// @ts-nocheck

import Vue from "vue"
import {mapMutations} from "vuex"
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength } from 'vuelidate/lib/validators'
import apidb from "@/providers/apidb"
import apiauth from "@/providers/apiauth"
import db from "@/helpers/localdb"
import notificationerror from "@/components/common/notifications/notification_error.vue"

export default Vue.extend({

  name: "formlogin",
  
  mixins: [validationMixin],

  validations: {
    username: { required, minLength: minLength(5), maxLength: maxLength(10) },
    password: { required, minLength: minLength(8) },
  },  

  components:{
    notificationerror
  },

  data: () => ({
    valid: true,
    //username: 'fulanito',
    //password: 'menganito',
    username: '',
    password: '',
    error: {
      title: "",
      message: "",
    }
  }),//data

  computed: {
    get_username_errors () {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.maxLength && errors.push('username must be at most 10 characters long')
      !this.$v.username.required && errors.push('username is required.')
      return errors
    },
    get_password_errors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      //!this.$v.password.minLength && errors.push('Min length of pass is 8')
      !this.$v.password.required && errors.push('password is required')
      return errors
    },
  },

  methods: {
    ...mapMutations(["set_islogged"]),

    async_login : async function(){
      this.$v.$touch()
      console.log("on async_submit: ",this.username, this.password)
      const usertoken = await apiauth.async_get_usertoken({username:this.username,password:this.password})

      if(usertoken.error) {
        this.error.title = "Error"
        this.error.message = usertoken.error.toString()
        ;(this.$refs.username as any).focus()
        return
      }

      db.save("usertoken",usertoken)
      ;this.set_islogged(true)
      ;this.$router.push({ name: "iprequest"})
    },

    clear () {
      this.$v.$reset()
      this.username = ''
      this.password = ''
      this.error = {title:"",message:""}
      ;(this.$refs.username as any).focus()
    },

  },
  
})
